import React from 'react'
import { TABLE_TYPE, withTableContext } from '../../context/TableContext'
import { EKOM_LINKS } from '../../EKOM_LINKS'
import { useContractsSlug } from '../../hooks/useContractsSlug'
import { useMsgsList } from '../../hooks/useMsgsList'
import { findLink } from '../../utils/findLink'
import { MsgsTable } from '../MsgsTable/MsgsTable'

const MsgsReceivedList = () => {

  const heads = [
    { id: 'deliveredAt', label: 'Datum ' },
    { id: 'state', label: '' },
    { id: 'subject', label: 'Předmět' },
    { id: 'attachment', label: '' },
    { id: 'objectName', label: 'Zadávací postup' },
    { id: 'senderOrganizationName', label: 'Odesílatel' },
  ]

  const { data, error, loading, totalCount } = useMsgsList(false)
  const { data: slugData } = useContractsSlug(data)

  const tableData = data.map(msg => ({
    id: msg.id,
    deliveredAt: msg.deliveredAt,
    subject: msg.subject,
    link_subject: EKOM_LINKS.listRecv + '/' + msg.id,
    senderOrganizationName: msg.senderOrganizationName,
    attachment: msg.attachmentCount,
    objectName: msg.objectName,
    link_objectName: findLink(msg, slugData),
    isRead: !!msg.readsCount,
    systemExtId: msg.systemExtId,
    objectExtId: msg.objectExtId,
    state: msg.extType?.name,
  }))

  return (
    <MsgsTable
      loading={loading}
      error={error}
      heads={heads}
      data={tableData}
      totalCount={totalCount}
    />
  )
}

export default withTableContext(MsgsReceivedList, TABLE_TYPE.IN)
